module.exports = __webpack_public_path__ + "img/bj-check.1878d737.jpg";